module.exports = __webpack_public_path__ + "static/media/HPP_Innovation_Icon.12f00cd5.svg";